export default __webpack_public_path__ + "media/images/images/icons/repo-forked-101b23a0f8da42a9abf369f32e274ce5.png";